import { ProjectInfo } from './project-info';
import { SessionInformation, SystemInfo } from './session-information';
import { IterationTerminologyType, RdxDevTerminologyType } from './teminology-type.enum';
import { User, USER_LICENSE_TYPE } from './user';
import { AppPermissions } from './app-permissions';
export class ApplicationConfig {
    private sessionInfo: SessionInformation;
    user: User;
    projectInfo: ProjectInfo; // probably never initialized with value other than null
    uatOnly: boolean;
    entityType2StandardFields: any[];
    companyId: number;
    companyName: string;
    uatAccounts: number[];
    iaEnabled: boolean;
    rdxEnabled: boolean;
    panayaUser: boolean;
    permissions: AppPermissions;
    devTerminology: RdxDevTerminologyType;
    iterationTerminology: IterationTerminologyType;
    hasSapAccount: boolean;
    language: string;
    userGuid: number;
    pendoKey: string;
    gtmId: string;
    oldUIAvailable: boolean;
    allowedFPR: boolean;
    hasPermission4InternalTools?: boolean;
    angularMode: number;
    systems: SystemInfo[];
    lastLoginTime: Date;
    showInternalData: boolean;
    isExternalUser: boolean;
    isOAuthUser: boolean;
    isProdContext: boolean;
    qtEnabled: boolean;

    get isExecuteUser(): boolean {
        return this.user.email.endsWith('@execute.ia') ?? false;
    }

    public get isRecorderEnabledForLoggedInUser(): boolean {
        return this.user.userLicenseType == USER_LICENSE_TYPE.EXTENDED || this.user.userLicenseType == USER_LICENSE_TYPE.AUTOMATION;
    }

    constructor(session: SessionInformation) {
        this.sessionInfo = session;
        this.user = session.user;
        this.projectInfo = session.projectInfo;
        this.uatOnly = session.uatOnly;
        this.entityType2StandardFields = session.entityType2StandardFields;
        this.companyId = session.companyId;
        this.companyName = session.companyName;
        this.uatAccounts = session.uatAccounts;
        this.iaEnabled = session.iaEnabled;
        this.rdxEnabled = session.rdxEnabled;
        this.panayaUser = session.panayaUser;
        this.permissions = session.permissions;
        this.devTerminology = session.devTerminology;
        this.iterationTerminology = session.iterationTerminology;
        this.hasSapAccount = session.hasSapAccount;
        this.language = session.language;
        this.pendoKey = session.pendoKey;
        this.userGuid = session.userGuid;
        this.gtmId = session.gtmId;
        this.oldUIAvailable = session.oldUIAvailable;
        this.hasPermission4InternalTools = session.hasPermission4InternalTools;
        this.angularMode = session.angularMode;
        this.allowedFPR = session.allowedFPR;
        this.systems = session.systems;
        this.lastLoginTime = session.lastLoginTime;
        this.showInternalData = session.showInternalData;
        this.isExternalUser = session.isExternalUser;
        this.isOAuthUser = session.isOAuthUser;
        this.isProdContext = session.prodContext;
        this.qtEnabled = session.qtEnabled;
    }

    isSelectedUatOnly(systemId: number): boolean {
        return this.uatAccounts?.indexOf(systemId) !== -1;
    }

    getSessionInformation(): SessionInformation {
        return { ...this.sessionInfo };
    }
}
